import { ApiClient } from '../../../shared/api/ApiClient';

export interface FallbackRate {
  id: string;
  shopId: string;
  postcodePattern: string;
  minWeightG: number;
  maxWeightG: number;
  priceMinorUnits: number;
  currency: string;
  serviceName: string;
  createdAt: string;
  updatedAt: string;
  shop?: { domain: string };
}

export interface FallbackRateInput {
  shopDomain: string;
  postcodePattern: string;
  minWeightG: number;
  maxWeightG: number;
  priceMinorUnits: number;
  currency: string;
  serviceName: string;
}

export type FallbackRatePatch = Partial<Omit<FallbackRateInput, 'shopDomain'>>;

export function listFallbackRates(api: ApiClient): Promise<{ items: FallbackRate[] }> {
  return api.get<{ items: FallbackRate[] }>('/admin/api/fallback-rates');
}

export function createFallbackRate(api: ApiClient, input: FallbackRateInput): Promise<FallbackRate> {
  return api.post<FallbackRate>('/admin/api/fallback-rates', input);
}

export function updateFallbackRate(
  api: ApiClient,
  args: { id: string; patch: FallbackRatePatch },
): Promise<FallbackRate> {
  return api.put<FallbackRate>(`/admin/api/fallback-rates/${args.id}`, args.patch);
}

export function deleteFallbackRate(api: ApiClient, id: string): Promise<void> {
  return api.delete<void>(`/admin/api/fallback-rates/${id}`);
}
